import React, { Component } from 'react';
import { translate } from '../../services';
import { SvgImage } from '..';
import { CloseLightIconNew, searchIcon } from '../../../style/images';
import { VariableInput } from '../../site';
import { PropTypes } from 'prop-types';
import { ViewSelector } from '../ViewSelector';
import { Box, InputBase, MenuItem, Select } from '@mui/material';

export class CartHeader extends Component {

  constructor(){
    super();
    this.state = {
      searchActive:false,
      searchValue : ""
    }
  }

  search = e => {
    if(!this.props.isFiltered){
      this.props.setIsFiltered(true)
    }
    const value = e.target.value;
    this.setState({searchValue:value})
    if(value!==""){
      this.makeSearchActive();
    }
    if(value===""){
      this.makeSearchInactive()
    }
    this.timeout && clearTimeout( this.timeout );
    this.timeout = setTimeout( () => this.props.onSearch( value ), 500 );
  }

  onOrder = selection => {
    this.props.onOrder( selection.value );
  }

  makeSearchInactive = ()=>{
    this.timeout && clearTimeout( this.timeout );
    this.timeout = setTimeout( () => this.props.onSearch( "" ), 500 );
    this.state.searchActive && this.setState({searchActive:false})
    this.setState({searchValue:""})
  }

  makeSearchActive = ()=>{
    !this.state.searchActive && this.setState({searchActive:true})
  }
  render() {
    const { orderableAttributes, orderedBy } = this.props;

    const value = orderableAttributes.filter((attr=>attr.name===orderedBy))[0]?.value
    return <div className="cart-header">
      <div className="left-panel">
        <div className="cart-search-panel">
          <div className='cart-search'>
            <SvgImage source={ searchIcon }/>
            <input className="cart-search-bar" placeholder={ translate( 'Search by product ID...' ) } value={this.state.searchValue} onChange={ this.search }/>
            {this.state.searchActive&&<>
            <Box sx={{flexGrow:1}}></Box>
            <div className='reset-icon'><SvgImage 
                source={ CloseLightIconNew } 
                onClick={ this.makeSearchInactive }
              /></div>
              </>}
          </div>
          
        </div>
        
      </div>
      { 
        !orderableAttributes || !orderableAttributes.length ? null : <div className="right-panel">
          <span className='sort'>{translate("Sort by:")}</span>
          <VariableInput 
            showAs="dropdown" 
            filter={ false } 
            data={ orderableAttributes } 
            textField="name" 
            valueField="value" 
            value={ value }
            placeholder_value={translate("Name")}
            onChange={ this.onOrder }
          />
          {this.props.siteSettings.properties.showViewSelector&&this.props.screenSize.width>900&&<ViewSelector view="cart"/>}
        </div> 
      }
    </div>;
  }
}

CartHeader.propTypes = {
  onSearch: PropTypes.func.isRequired,
  onOrder: PropTypes.func.isRequired,
  orderedBy: PropTypes.string,
};